import { usePolling } from '@/shared/hooks/use-polling';
import { listAccessRequests } from '../api/list-access-requests';

/** Pending agent requests, refreshed every 5 s: an agent is waiting on the other side. */
export function useAccessRequests() {
  return usePolling(listAccessRequests, 5_000);
}
